import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=cb0558d0"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports